import _extends from '@babel/runtime/helpers/esm/extends';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { ScrollSyncContext } from './ScrollSync.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * MODIFIED FROM react-scroll-sync
 *
 * ScrollSyncPane Component
 *
 * Wrap your content in it to keep its scroll position in sync with other panes
 *
 * @param groups
 * @example ./example.md
 */

var ScrollSyncPane = /*#__PURE__*/function (_Component) {
  _inherits(ScrollSyncPane, _Component);

  var _super = _createSuper(ScrollSyncPane);

  function ScrollSyncPane() {
    var _this;

    _classCallCheck(this, ScrollSyncPane);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "toArray", function (groups) {
      return [].concat(groups);
    });

    return _this;
  }

  _createClass(ScrollSyncPane, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props = this.props,
          enabled = _this$props.enabled,
          group = _this$props.group,
          syncContext = _this$props.syncContext;
      var unregisterPane = syncContext.unregisterPane;
      if (enabled) unregisterPane(this.node, this.toArray(group));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          group = _this$props2.group,
          syncContext = _this$props2.syncContext,
          notPaginated = _this$props2.notPaginated;
      var _registerPane = syncContext.registerPane;
      return children({
        registerPane: function registerPane(node) {
          if (notPaginated) {
            var virtualizedBody = node.querySelector('.virtualized-body-wrapper');

            if (virtualizedBody) {
              _registerPane(virtualizedBody, _this2.toArray(group));
            }
          }

          return _registerPane(node, _this2.toArray(group));
        }
      });
    }
  }]);

  return ScrollSyncPane;
}(Component);

_defineProperty(ScrollSyncPane, "defaultProps", {
  group: 'default',
  enabled: true
});

var ScrollSyncPane$1 = (function (props) {
  return /*#__PURE__*/React.createElement(ScrollSyncContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(ScrollSyncPane, _extends({}, props, {
      syncContext: context
    }));
  });
});

export default ScrollSyncPane$1;
//# sourceMappingURL=ScrollSyncPane.js.map
